import {
  CREATE_ACCOUNTITEM_NEW_RECORD,
  CREATE_ACCOUNTITEM_NEW_RECORD_SUCCESS,
  CREATE_ACCOUNTITEM_NEW_RECORD_ERROR,  
  
  GET_ACCOUNTITEM_NEW_RECORD,
  GET_ACCOUNTITEM_NEW_RECORD_SUCCESS,
  GET_ACCOUNTITEM_NEW_RECORD_ERROR,  

  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,

  GET_ACCOUNT_RECORDS,
  GET_ACCOUNT_RECORDS_SUCCESS,
  GET_ACCOUNT_RECORDS_ERROR

} from "../actions";

export const getRecords = (recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, vocabularyId, hasUserAccount, profile, params, searchInputName) => ({
  type: GET_ACCOUNT_RECORDS,
  payload: { recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, vocabularyId, hasUserAccount, profile, params, searchInputName },
});

export const getRecordsSuccess = (recordList) => ({
  type: GET_ACCOUNT_RECORDS_SUCCESS,
  payload: recordList,
});

export const getRecordsError = (message) => ({
  type: GET_ACCOUNT_RECORDS_ERROR,
  payload: { message },
});

export const getAccountItemNewRecord = (accountId, history) => ({
    type: GET_ACCOUNTITEM_NEW_RECORD,
    payload: {accountId, history}
  });

export const getAccountItemNewRecordSuccess = (recordCreated) => ({
  type: GET_ACCOUNTITEM_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const getAccountItemNewRecordError = (message) => ({
  type: GET_ACCOUNTITEM_NEW_RECORD_ERROR,
  payload: { message },
});

export const createAccountItemNewRecord = (newRecord, history) => ({
    type: CREATE_ACCOUNTITEM_NEW_RECORD,
    payload: {newRecord, history}
  });

export const createAccountItemNewRecordSuccess = (recordCreated) => ({
  type: CREATE_ACCOUNTITEM_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createAccountItemNewRecordError = (message) => ({
  type: CREATE_ACCOUNTITEM_NEW_RECORD_ERROR,
  payload: { message },
});


export const hideNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_HIDE_CLICK,
    payload: {},
  });

export const toggleNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
    payload: {},
  });

export const setRecordType = (recordTypeSelected) => ({
    type: SET_RECORD_TYPE,
    payload: {recordTypeSelected},
  });

export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});